<template>
  <a-drawer
      title="Documenten"
      placement="right"
      :closable="true"
      :visible="visible"
      :after-visible-change="afterVisibleChange"
      @close="onClose"
      width="600"
  >
    <AttachableTableComponent :attachables="attachables"></AttachableTableComponent>
  </a-drawer>
</template>
<script>
import AttachableTableComponent from "./TableComponent";

export default {
  name: "AttachableDrawerTableComponent",
  props: {
    attachables: {
      type: Array,
      required: true
    },
    visible: {
      type: Boolean,
      required: true
    },
  },
  components: {
    AttachableTableComponent,
  },
  data() {
    return {
      editing: false,
      updateNameLoading: false,
      processLoading: false,
      unmatchLoading: false,
    }
  },
  methods: {
    afterVisibleChange(val) {
      this.$emit('after-visible-change', val);
    },
    onClose() {
      this.$emit('close');
    },
  }
}
</script>

<style scoped>

</style>
